export const DateTimeFormat = {
  DatePicker: 'MMM DD, YYYY',
  Database: 'YYYY-MM-DD'
};
